import APIError from './api.error';

export default class APIMappedError extends APIError {
    constructor(
        message: string,
        code?: string,
        status?: number,
        target?: string,
        details?: unknown,
        innerError?: unknown,
        cause?: Error
    ) {
        const theCode = code || 'EDF:APIMappedError';
        super(message, theCode, status, target, details, innerError, cause);
    }

    override toJSON(): {
        name: string;
        message: string;
        code: string;
        status?: number;
        target?: string;
        details?: unknown;
        innerError?: unknown;
    } {
        return {
            name: this.name,
            message: this.message,
            code: this.code,
            status: this.status,
            target: this.target,
            details: this.details,
            innerError: this.innerError,
        };
    }
}
